export default __webpack_public_path__ + "static/media/nft3.6fe3c4c1.jpeg";